import { createFileRoute } from '@tanstack/react-router';

import { ContractDetailPage } from '../contracts/detail/ContractDetailPage';

export const Route = createFileRoute('/_app/contracts/$id')({
    component: ContractDetailPage,
});
